// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gameover {\n  position: fixed;\n  z-index: 1;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: \"Sigmar One\";\n  color: white;\n  flex-direction: column;\n}\n\n.gameover-title {\n  font-size: 10rem;\n  -webkit-text-stroke: 2px black;\n}\n.gameover-text {\n  font-size: 2rem;\n}\n", ""]);
// Exports
module.exports = exports;
